module.exports = __webpack_public_path__ + "img/characteristic1.295f3e60.png";